import {
  CLEAR_TABLE_DATA
  INIT_TABLE_DATA
  SET_TABLE_DATA
} from './actionTypes'

export clearTableData = ->
  type: CLEAR_TABLE_DATA

export initTableData = (data) ->
  type: INIT_TABLE_DATA
  payload: { data }

export setTableData = (data) ->
  type: SET_TABLE_DATA
  payload: { data }